import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The GitHub presentation template is available as a Figma library for members of the GitHub organization.`}</p>
    <h3>{`How to use`}</h3>
    <ol>
      <li parentName="ol">{`Open `}<a parentName="li" {...{
          "href": "https://www.figma.com/file/0mXCPvPvDgbtiMEIa5Z8DSh9/GitHub-presentation-template"
        }}><inlineCode parentName="a">{`GitHub Presentation Template`}</inlineCode></a>{` located in the `}<a parentName="li" {...{
          "href": "https://www.figma.com/files/project/5764839"
        }}><inlineCode parentName="a">{`Presentations`}</inlineCode></a>{` project in the Primer team in Figma`}</li>
    </ol>
    <img width="656" alt="Presentation template in Figma" src="https://user-images.githubusercontent.com/10384315/101224794-96c37500-3644-11eb-9bf6-b4b38c7667eb.png" />
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Duplicate the file into your own drafts`}</li>
    </ol>
    <img width="656" alt="The dropdown arrow in the file name shows a context menu with Duplicate drafts option highlighted" src="https://user-images.githubusercontent.com/10384315/101224924-ec981d00-3644-11eb-8b6e-7a3aa0fba6a2.png" />
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Open the duplicated file and configure your own presentation`}</li>
    </ol>
    <Note mdxType="Note">**Tip:** Remember to rename the duplicated presentation file.</Note>
    <p>{`For more information on how to duplicate files in Figma, please refer to `}<a parentName="p" {...{
        "href": "https://help.figma.com/hc/en-us/articles/360038511533-Duplicate-a-File#duplicate"
      }}>{`Figma's documentation`}</a>{`.`}</p>
    <Note mdxType="Note">
      <p>{`😕 `}<strong parentName="p">{`Having trouble?`}</strong>{` Message us in `}<a parentName="p" {...{
          "href": "https://github.slack.com/archives/CPA865D9S"
        }}>{`#primer-design`}</a>{` for assistance.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      